import axios, { AxiosRequestConfig } from 'axios';
import { ACCESS_TOKEN } from 'utils/storageKeys';
import { getTrackingSessionData } from './tracking-session';

const basicConfig: AxiosRequestConfig = {
  // Andrew 01 Jun: Create local .env file and put it there
  baseURL: process.env.REACT_APP_API_URL,
};

const addTrackingSessionData = (config: AxiosRequestConfig) => {
  const data = getTrackingSessionData();

  return {
    ...config,
    headers: {
      ...config.headers,
      'x-tracking-session-start-timestamp': data?.startTimestamp,
      'x-tracking-session-uuid': data?.uuid,
      'x-tracking-session-user-id': data?.userId,
    },
  };
};

const apiInstance = axios.create(basicConfig);

apiInstance.interceptors.request.use(async (configuration) => {
  const accessToken = localStorage.getItem(ACCESS_TOKEN);

  return {
    ...configuration,
    headers: {
      ...configuration.headers,
      Authorization: `Bearer ${accessToken}`,
    },
  };
});

apiInstance.interceptors.request.use(addTrackingSessionData);

export default apiInstance;

const publicApi = axios.create(basicConfig);

publicApi.interceptors.request.use(addTrackingSessionData);

export { publicApi };
